import React from "react";
import Navbar from "../../components/common/Header/Navbar";
import bannerimg from "../../assets/Recharge_api_images/recharge_banner.png";
import missionvissonimg from "../../assets/Recharge_api_images/recharge_api_img.png";
import "../../styles/recharge_api.css";


import airtelImg from "../../assets/Recharge_api_images/airtel.jpg";
import jioImg from "../../assets/Recharge_api_images/jio.png";
import bsnlImg from "../../assets/Recharge_api_images/bsnl.png";
import dishtvImg from "../../assets/Recharge_api_images/dishtv.png";
import viImg from "../../assets/Recharge_api_images/vi.png";
import videoconImg from "../../assets/Recharge_api_images/videocon.png";
import sundirectImg from "../../assets/Recharge_api_images/sundirect.png";
import tataplayImg from "../../assets/Recharge_api_images/tataplay.png";

import benefitBanner from "../../assets/Recharge_api_images/benefit_banner.png";

import securityMeasuresImage from "../../assets/Recharge_api_images/security1.png";
import securitysecurityMeasuresImage from "../../assets/Recharge_api_images/security2.png";

import integrationProcessImage from "../../assets/Recharge_api_images/integration_background.png";

const Services = () => {
  const FeatureBox = ({ title, description, isPrimary = false }) => (
    <div
      className={`feature-box ${isPrimary ? "feature-box-primary" : "feature-box-secondary"
        }`}
    >
      <h4 className="feature-title font-lato text-[20px] font-bold">{title}</h4>
      <p className="feature-description text-ellipsis  font-lato text-[17px] font-normal leading-[26px]">
        {description}
      </p>
    </div>
  );

  // ✅ you used values in CoreValues & HowItWorks but didn’t define it
  const values = [
    { title: "Integrity", desc: "We believe in transparency and trust." },
    { title: "Innovation", desc: "We build solutions for tomorrow." },
  ];

  // ✅ UPDATED BenefitCard (changes marked below)
  const BenefitCard = ({ icon, title, description, isBlue = false }) => (
    <div
      className={`benefit-card group 
    p-6 rounded-3xl shadow-lg transition-colors duration-300 cursor-pointer
    flex flex-col items-center text-center`} // 🟢 centered everything
    >
      {/* 🟢 Centered and enlarged image */}
      <div className="card-icon-container mb-4 flex justify-center">
        {icon ? (
          <img
            src={icon}
            alt={title}
            className="
          
            object-contain
            w-[80px] h-[80px]   /* Default size */
            sm:w-[135px] sm:h-[90px]  /* Small screens */
            md:w-[100px] md:h-[100px] /* Tablets */
            lg:w-[110px] lg:h-[110px] /* Laptops */
            xl:w-[120px] xl:h-[120px] /* Desktops */
            2xl:w-[auto] 2xl:h-[75px] /* Very large screens */
          "
          />
        ) : (
          <div className="card-icon-placeholder w-12 h-12"></div>
        )}
      </div>

      {/* 🟡 Slightly reduced title font size */}
      <h3
        className="
        card-title text-gray-900 
        text-[19px] sm:text-[18px] md:text-[17px]
        font-semibold mb-2 transition-colors duration-300
      "
      >
        {title}
      </h3>

      {/* 🟡 Reduced font size and line height for description */}
      <p
        className="
      tracking-tight
        card-description text-[#6E6E6E] 
        transition-colors duration-300 font-lato
        text-[14px] sm:text-[15px] md:text-[16px]
        leading-[20px] sm:leading-[22px] md:leading-[25px]
      "
      >
        {description}
      </p>
    </div>
  );



  const renderImageCard = (imageSrc, altText, title, description, linkText) => (
    <div className="image-card-container">
      {/* The main background image holder (dark curved shape) */}
      <div className="image-card-background">
        {imageSrc ? (
          <img src={imageSrc} alt={altText} className="content-image" />
        ) : (
          <div className="image-placeholder"></div>
        )}
      </div>

      {/* The nested white card with text overlay */}
      <div className="image-text-card">
        <h3>{title}</h3>
        <p>{description}</p>
        <a href="#" className="see-more-link">
          {linkText} →
        </a>
      </div>
    </div>
  );

  return (
    <>

      <div className="relative w-full h-[300px] md:h-auto min-h-52">
        <img
          src={bannerimg}
          alt="About Banner"
          className="w-full h-full object-cover" // Added h-full and object-cover to make sure the image fills the container height
        />
        <div className="absolute inset-0  flex flex-col items-center justify-center px-6 py-12 md:pb-0"> {/* Added vertical padding */}
          <h1
            className="text-white text-4xl md:text-6xl lg:text-[80px] font-normal font-goldman text-center leading-tight md:leading-normal" // Made font size responsive
          >
            Recharge API
          </h1>

          <p
            className="text-[#D9D9D9] text-base md:text-xl lg:text-[22px] text-center max-w-2xl font-dmsans font-normal leading-normal tracking-[0.22px] mt-2" // Made font size responsive and added margin top
          >
            Enable instant and seamless prepaid and postpaid mobile, DTH, and
            data card recharges.

          </p>
        </div>
      </div>




      {/* Content Section */}
      <section className="recharge-api-section">
        <div className="content-container">
          {/* Left Column */}
          <div className="text-and-features-column">
            <p className="section-tag">OUR CORE API SERVICES</p>
            <h1 className="main-title">
              Recharge API – Instant Mobile,<br></br> DTH & Data Recharges
            </h1>
            <p className="main-description font-lato text-[17px] font-normal leading-[26px]">
              Enable instant and seamless prepaid and postpaid mobile recharges,
              ensuring smooth DTH subscriptions and hassle-free data card
              top-ups, delivering uninterrupted digital connectivity.
            </p>

            <div className="features-grid">
              <FeatureBox
                title="Instant Recharges & Updates"
                description="Get instant recharges with real-time tracking for a fast, hassle-free experience."
              />
              <FeatureBox
                title="Wide Telecom Compatibility"
                description="Seamlessly integrates with all major providers like Airtel, Jio, and VI ."
              />
              <FeatureBox
                title="Secure API Architecture"
                description="Prevent fraud with advanced security and a secure API architecture.."
              />
              <FeatureBox
                title="Multi-Operator Support"
                description="Ensure uninterrupted service with multi-operator support for seamless connectivity."
              />

            </div>
          </div>

          {/* Right Column */}
          <div className="illustration-column">
            <img
              src={missionvissonimg}
              alt="Mobile Recharge Illustration"
              className="recharge-illustration"
            />
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <div>
        <section className="benefits-section relative overflow-hidden">
          <div
            className="absolute top-0 left-0 w-full h-[400px]  z-0"
            style={{
              backgroundImage: `url(${benefitBanner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
          {/* 3. Apply the style object and add an overlay div */}
          <div className="benefits-header-content-bg">
            {/* 4. Overlay div for the dark blue tint effect from the original image */}
            <div className="benefits-header-overlay"></div>
          </div>

          <div className="benefits-header-content">
            <div className="header-text-container">
              <p className="header-tag">BENEFITS & USE CASES</p>
              <h2 className="header-title">
                Maximize Efficiency with Our APIs
              </h2>
            </div>
            <div className="header-description-container">
              <p className="header-description text-justify">
                Enhance your business with secure, fast, and scalable API
                solutions. Streamline transactions, optimize operations, and
                improve customer experience effortlessly.
              </p>
            </div>
          </div>


          <div className="benefits-cards-grid-container">
            <div className="benefits-cards-grid-recharge">
              <BenefitCard
                icon={airtelImg}
                title="Airtel Recharge API"
                description="
      Enhance your platform with Jio’s powerful recharge solutions.
      "
              />

              <BenefitCard
                icon={jioImg}
                title="Jio Recharge API"
                description="Enhance your platform with Jio’s powerful recharge solutions. "
              />

              <BenefitCard
                icon={bsnlImg}
                title="BSNL Recharge API"
                description="Reach customers across India with BSNL Recharge APIs."
              />

              <BenefitCard
                icon={dishtvImg}
                title="Dish TV Recharge API"
                description="Simplify your DTH recharge experience with Dish TV APIs."
              />

              <BenefitCard
                icon={viImg}
                title="VI (Vodafone Idea) Recharge API"
                description="Enable quick and secure recharges with VI Recharge APIs."
              />

              <BenefitCard
                icon={videoconImg}
                title="Videocon D2H Recharge API"
                description="Streamline your DTH operations using Videocon D2H APIs. "
              />

              <BenefitCard
                icon={sundirectImg}
                title="Sun Direct Recharge API"
                description="Deliver instant and accurate DTH recharges through Sun Direct APIs."
              />

              <BenefitCard
                icon={tataplayImg}
                title="Tata Play Recharge API"
                description="Simplify entertainment recharges with Tata Play APIs."
              />
            </div>
          </div>


        </section>
      </div>

      {/* Core Values & How It Works */}

      <section
        className="relative py-16 px-4 md:px-8 lg:px-16 overflow-hidden"
        style={{
          backgroundImage: `url(${integrationProcessImage})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-7xl mx-auto">
          {/* --- Top Section Header and Title --- */}
          <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]">
            Integration & Security
          </span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-12 leading-tight">
            Seamless Integration With <br />
            Advanced Security
          </h1>


          <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
            <div className="relative w-full lg:w-1/2 min-h-[300px]">
              <div className="w-full h-full absolute top-0 left-0">
                <img
                  src={securityMeasuresImage}
                  alt="Integration Process"
                  className="w-[90%] h-full object-cover rounded-xl shadow-2xl"
                />
              </div>

              <div
                className="absolute top-1/4 right-0 bg-[#F9F9F9] rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]
             flex flex-col items-start p-6 flex-1"
              >
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Integration Process
                </h3>
                <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                  Seamlessly integrate our APIs with your platform using our
                  well-documented.
                </p>
                <a
                  href="#"
                  className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150"
                >
                  SEE MORE <span className="ml-2">→</span>
                </a>
              </div>
            </div>

            {/* Right Side: Checklist */}
            <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
              <ul className="space-y-6">
                {[
                  // "Sign Up - Get API access and credentials.",
                  "Sign Up – Get API access, credentials, and 100 free credits after onboarding.",
                  "API Documentation – Use our developer-friendly guides for easy integration.",
                  // "Testing - Run test transactions in a sandbox environment.",
                  " Testing – Run test transactions in a secure sandbox environment.",
                  // "Go Live - Deploy API for real-time transactions.",
                  "Go Live – Deploy APIs for real-time transactions and start scaling instantly.",
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#00AFEF]  font-bold text-lg mr-3 mt-1">
                      ✓
                    </span>
                    <p className="text-lg text-gray-700">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* ------------------------------------- */}
          {/* --- 2. Security Measures Section --- */}
          {/* ------------------------------------- */}

          <div className="flex flex-col lg:flex-row items-start justify-between gap-12 mb-20">
            <div className="w-full lg:w-1/2 pt-24 lg:pt-0">
              <span className="font-lato text-[14px] font-bold leading-[24px] tracking-[1.68px] uppercase text-[#2F56A6]">
                Integration & Security
              </span>
              {/* Removed <br></br> */}

              {/* Added mt-4 or mb-4 to the list for separation */}
              <ul className="space-y-6 mt-4">
                {[
                  // "Sign Up - Get API access and credentials.",
                  "End-to-End Encryption – Ensures complete data protection and privacy",
                  // "API Documentation - Use our developer-friendly guides.",
                  "Fraud Detection System – Prevents unauthorized or suspicious transactions",
                  "Transaction Logs & Alerts – Monitor recharges and detect anomalies in real time.",
                  "IP Whitelisting – Approve and process responses only from whitelisted IPs.",
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#00AFEF] font-bold text-lg mr-3 mt-1">
                      ✓
                    </span>
                    <p className="text-lg text-gray-700">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative w-full lg:w-1/2 min-h-[300px]">
              <div className="w-full h-full absolute top-0 left-0">
                <img
                  src={securitysecurityMeasuresImage}
                  alt="Integration Process"
                  className="w-[90%] h-full object-cover rounded-xl shadow-2xl"
                />
              </div>

              <div className="absolute top-1/4 right-0 bg-[#F9F9F9] p-6 rounded-xl  w-11/12 md:w-3/4 lg:w-[350px]">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Integration Process
                </h3>
                <p className="text-gray-600 mb-4 text-sm  text-[18px] font-normal leading-[26px]">
                  Seamlessly integrate our APIs with your platform using our
                  well-documented.
                </p>
                <a
                  href="#"
                  className="flex items-center text-[#00AFEF] font-medium text-sm hover:text-[#00AFEF] transition duration-150"
                >
                  SEE MORE <span className="ml-2">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
